import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class ConfigTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "parameterColumn", title: "Parameter" },
        { name: "valueColumn", title: "Description" }
      ],
      rows: [
        { parameterColumn: 'Auswahl', valueColumn: 'Lassen Sie dieses Feld leer' },
        { parameterColumn: 'Bezeichnung', valueColumn: 'Wählen Sie einen Namen für Ihre Kamera, z. B. "Kameraeingang".' },
        { parameterColumn: 'Gültig für Gerät', valueColumn: 'Wählen Sie hier die IP-Adresse Ihrer Kamera' },
        { parameterColumn: 'Protokoll', valueColumn: 'Hier wählen Sie TCP' },
        { parameterColumn: 'Umgeleitete Ports - Öffentlich', valueColumn: 'Wählen Sie hier den gleichen Port wie in Schritt 1 eingestellt: 8081 für Kamera 1, 8082 für Kamera 2, usw.' },
        { parameterColumn: 'Umgeleitete Ports - Privater Klient', valueColumn: 'Wählen Sie auch hier den gleichen Port wie in Schritt 1 eingestellt: 8081 für Kamera 1, 8082 für Kamera 2, usw.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

ConfigTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ConfigTable)